export const HOME_ROUTE = {
  home: {
    path: '/'
  }
};
